import * as React from "react";
import type {SVGProps, FunctionComponent} from "react";
import {ReactUtils} from "../../../../utils/ReactUtils";

interface IViewComponentTogglerProps {
	readonly onClick: (value: boolean) => void;
	readonly isActive: boolean;
	readonly title: string;
	readonly label?: string;
	readonly IconComponent?: FunctionComponent<SVGProps<SVGSVGElement>>;
}

export const ViewComponentTogglerV5 = (props: IViewComponentTogglerProps) => {
	const IconComponent = props.IconComponent;

	const onClick = () => {
		props.onClick(!props.isActive);
	};

	return (
		<div
			className={ReactUtils.cls("btn", {active: props.isActive})}
			title={props.title}
			onClick={onClick}
		>
			{IconComponent && <IconComponent />}
			{props.label || ""}
		</div>
	);
};
